/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DataGrid = _interopRequireDefault(require("../../containers/DataGrid"));
var _MovementDriver = _interopRequireDefault(require("./MovementDriver"));
var _MovementGrid = _interopRequireDefault(require("./MovementGrid"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MovableDataGrid = function MovableDataGrid(_ref) {
  var gridBoundaries = _ref.gridBoundaries,
    initialMarkerCoordinate = _ref.initialMarkerCoordinate,
    movementRatio = _ref.movementRatio,
    stateType = _ref.stateType,
    children = _ref.children,
    dataId = _ref.dataId,
    epgEndTime = _ref.epgEndTime,
    epgStartTime = _ref.epgStartTime,
    onCoordinateChange = _ref.onCoordinateChange,
    onLeftBoundaryReached = _ref.onLeftBoundaryReached,
    onLoadCoordinateData = _ref.onLoadCoordinateData,
    onRightBoundaryReached = _ref.onRightBoundaryReached,
    onTopBoundaryReached = _ref.onTopBoundaryReached,
    onBottomBoundaryReached = _ref.onBottomBoundaryReached,
    updatedAt = _ref.updatedAt;
  return /*#__PURE__*/_react["default"].createElement(_MovementGrid["default"], {
    gridBoundaries: gridBoundaries,
    initialMarkerCoordinate: initialMarkerCoordinate,
    onBottomBoundaryReached: onBottomBoundaryReached,
    onCoordinateChange: onCoordinateChange,
    onLeftBoundaryReached: onLeftBoundaryReached,
    onRightBoundaryReached: onRightBoundaryReached,
    onTopBoundaryReached: onTopBoundaryReached
  }, function (_ref2) {
    var onMove = _ref2.onMove,
      onMoveTo = _ref2.onMoveTo,
      markerCoordinate = _ref2.markerCoordinate,
      transitionInfo = _ref2.transitionInfo;
    return /*#__PURE__*/_react["default"].createElement(_MovementDriver["default"], {
      movementRatio: movementRatio,
      onMove: onMove
    }, function (_ref3) {
      var onUp = _ref3.onUp,
        onDown = _ref3.onDown,
        onLeft = _ref3.onLeft,
        onRight = _ref3.onRight;
      return /*#__PURE__*/_react["default"].createElement(_DataGrid["default"], {
        dataId: dataId,
        epgEndTime: epgEndTime,
        epgStartTime: epgStartTime,
        gridBoundaries: gridBoundaries,
        markerCoordinate: markerCoordinate,
        onLoadCoordinateData: onLoadCoordinateData,
        stateType: stateType,
        updatedAt: updatedAt
      }, function (_ref4) {
        var coordinateData = _ref4.coordinateData,
          loadCoordinate = _ref4.loadCoordinate;
        return children({
          onUp: onUp,
          onDown: onDown,
          onLeft: onLeft,
          onRight: onRight,
          onMoveTo: onMoveTo,
          coordinateData: coordinateData,
          markerCoordinate: markerCoordinate,
          transitionInfo: transitionInfo,
          loadCoordinate: loadCoordinate,
          epgEndTime: epgEndTime,
          epgStartTime: epgStartTime
        });
      });
    });
  });
};
MovableDataGrid.propTypes = {
  children: _propTypes["default"].func,
  dataId: _propTypes["default"].string,
  epgEndTime: _propTypes["default"].number,
  epgStartTime: _propTypes["default"].number,
  gridBoundaries: _propTypes["default"].shape({
    xFrom: _propTypes["default"].number,
    xTo: _propTypes["default"].number,
    yFrom: _propTypes["default"].number,
    yTo: _propTypes["default"].number
  }),
  initialMarkerCoordinate: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  movementRatio: _propTypes["default"].any,
  onBottomBoundaryReached: _propTypes["default"].func,
  onCoordinateChange: _propTypes["default"].func,
  onLeftBoundaryReached: _propTypes["default"].func,
  onLoadCoordinateData: _propTypes["default"].func,
  onRightBoundaryReached: _propTypes["default"].func,
  onTopBoundaryReached: _propTypes["default"].func,
  stateType: _propTypes["default"].string,
  updatedAt: _propTypes["default"].number
};
var _default = MovableDataGrid;
exports["default"] = _default;